import 'velocity-animate';
(function () {
    //speed of the transition
    const speed = 300;

    // Hamburger and mainmenu
    const hamburger = document.querySelector(".hamburger");

    // state for menu
    let mainNavigationOpen = false;

    // current scroll position
    let scrollY = 0;

    // slide up and down mainmenu container
    hamburger.addEventListener("click", function () {
        // update toggle button with accessible stuff
        this.classList.toggle("is-active");
        hamburger.setAttribute('aria-expanded', JSON.stringify(!JSON.parse(hamburger.getAttribute('aria-expanded'))));
        // add body class to control other areas (like the actual nav area)
        document.body.classList.toggle("nav-open");
        // open or  nav
        const mainNavigation = document.getElementById("main-navigation");
        if (!mainNavigationOpen) {
            Velocity(mainNavigation, "slideDown", {duration: speed});
            // Hint: in ff position sticky in a container with negativ position fixed doesn't work
            // as a workaround position fixed
            const header = document.querySelector("header.banner");
            header.style.position = 'fixed';
            // fix body
            scrollY = window.scrollY;
            const body = document.body;
            body.style.position = 'fixed';
            body.style.top = `-${scrollY}px`;
            body.style.paddingRight = "15px";
        } else {
            Velocity(mainNavigation, "slideUp", {duration: speed});
            // Revert header back to position sticky
            const header = document.querySelector("header.banner");
            header.style.position = 'sticky';
            // scroll to old position
            const body = document.body;
            body.style.position = '';
            body.style.top = '';
            body.style.paddingRight = "0";
            window.scrollTo(0, parseInt(scrollY || '0'));
        }
        mainNavigationOpen = !mainNavigationOpen;
    });

    /**
     * Open or close submenu container
     * @param container {HTMLElement}
     * @param open {boolean}
     */
    function toggleMenuContainer(container, open) {
        const submenu = container.querySelector("ul")
        const activeSubmenu = container.querySelector("li.active")
        const toggler = container.querySelector(".submenu-toggler")
        // set ariaExpanded
        toggler.setAttribute('aria-expanded', JSON.stringify(open));
        // remove active class from container and all submenus
        container.classList.toggle("active");
        if(activeSubmenu !== null) {
            activeSubmenu.classList.remove("active");
        }
        // open or close menu
        if(open) {
            submenu.style.display = "none"
            Velocity(submenu, "slideDown", {duration: speed});
        } else {
            // on a newly loaded element we need this, otherwise the element is hidden by the class
            submenu.style.display = "block"
            Velocity(submenu, "slideUp", {duration: speed});
        }
    }

    // Control submenu behaviour.
    // slide up and down submenus containers
    const submenus = document.querySelectorAll(".submenu-toggler");
    for (let i = 0; i < submenus.length; i++) {
        submenus[i].addEventListener("click", function (e) {
            e.preventDefault();
            const li = this.parentElement;

            // close old submenu
            const oldActive = document.querySelector("#main-navigation li.active ul");
            if(oldActive !== null && li !== oldActive.parentElement) {
                toggleMenuContainer(oldActive.parentElement, false)
            }

            // handle current menu and open or close it
            const openMenu = !JSON.parse(this.getAttribute('aria-expanded'));
            toggleMenuContainer(li, openMenu)
        });
    }

    // size header. But be aware of scrolled headers
    const body = document.querySelector("body");
    window.addEventListener('scroll', () => {
        if(window.scrollY !== 0) {
            body.classList.add('scrolled');
        } else if (!body.classList.contains('nav-open')) {
            body.classList.remove('scrolled');
        }
    })
})()
